import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Page404 from "./common/Page404";
import routes from "./routing";
import Layout from "./routing/Layout";

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/assets/css/styles.css';

function App() {
  const router = createBrowserRouter([
    {
      element: <Layout />,
      errorElement: <Page404 />,
      children: routes,
    }
  ]);
  return (
    <>
       <RouterProvider router={router} />
    </>
  );
}

export default App;
